/**
 * Created by lei.you on 2017/11/27.
 */
import Vue from "vue";
import Vuex from "vuex";

import homeState from "./home/state";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    homeState: homeState
  }
});
